import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { convertSampleCollectionDate } from "@app/utils";
import useExpectedDrawDates from "@app/hooks/useExpectedDrawDates";

const messages = defineMessages({
  mobilePhlebotomyTimeslotsOncDescription: {
    id: "mobilePhlebotomyTimeslotsOncDescription",
    defaultMessage:
      "Your provider would like you to have your blood drawn by {sampleCollectionDate}, so please select time slots on or before that date.",
  },
  mobilePhlebotomyTimeslotsProsperaDescription: {
    id: "mobilePhlebotomyTimeslotsProsperaDescription",
    defaultMessage:
      "Your provider would like you to have your blood drawn around {resultExpectedByDate}, so please select time slots near that date.",
  },
  mobilePhlebotomyTimeslotsDescription: {
    id: "mobilePhlebotomyTimeslotsDescription",
    defaultMessage:
      "Please select three time slots across three different dates to ensure that we can match you with an appointment.",
  },
});

const TimeslotsDescription: FC = () => {
  const intl = useIntl();
  const { isOncologyOrder, sampleCollectionDate, prosperaEbdd } =
    useExpectedDrawDates();

  return (
    <>
      {isOncologyOrder && sampleCollectionDate && (
        <>
          {intl.formatMessage(
            messages.mobilePhlebotomyTimeslotsOncDescription,
            {
              sampleCollectionDate: convertSampleCollectionDate(
                sampleCollectionDate.toString()
              ),
            }
          )}{" "}
        </>
      )}
      {prosperaEbdd && (
        <>
          {intl.formatMessage(
            messages.mobilePhlebotomyTimeslotsProsperaDescription,
            {
              resultExpectedByDate: convertSampleCollectionDate(
                prosperaEbdd.toISOString()
              ),
            }
          )}{" "}
        </>
      )}
      {intl.formatMessage(messages.mobilePhlebotomyTimeslotsDescription)}
    </>
  );
};

export default TimeslotsDescription;
